// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1EyLa","errors":"Errors_errors__3TQJk"};